
import { ref } from '@vue/composition-api';
import { Toggle } from '05-ui-kit';
import { useContext } from '@nuxtjs/composition-api';
import getCurrentDate from '~/helper/getDateDayYear';
import type Question from '~/type/Question';
import AnswerForm from '~/components/product/AnswerForm/AnswerForm.vue';
type RequestTypeLike = Awaited<ReturnType<typeof context.$api.question.like>>['result'];
type RequestTypeDislike = Awaited<ReturnType<typeof context.$api.question.dislike>>['result'];
type RequestTypeAddComment = Awaited<ReturnType<typeof context.$api.question.addComment>>['result'];
const __sfc_main = {};
__sfc_main.props = {
  productId: {
    key: "productId",
    required: true,
    type: Number
  },
  parentQuestionId: {
    key: "parentQuestionId",
    required: false,
    type: String
  },
  question: {
    key: "question",
    required: true,
    type: null
  },
  activeField: {
    key: "activeField",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const context = useContext();
  const likes = ref(props.question?.like?.count || 0);
  const dislikes = ref(props.question?.dislike?.count || 0);
  const activeLike = ref(props.question?.like?.active);
  const activeDislike = ref(props.question?.dislike?.active);
  function onError() {
    /**
     * Захаркодили текст ошибки, потому что с бэка приходит неправильный текст ошибки, на самом деле нужно просто авторизоваться
     */
    new context.$simpleError({
      name: 'Произошла ошибка',
      message: 'Требуется авторизация'
    });
  }
  function onClickThumbs({
    response
  }: {
    response: {
      result: RequestTypeLike | RequestTypeDislike;
    };
  }) {
    likes.value = response.result?.amounts?.likes;
    dislikes.value = response.result?.amounts?.dislikes;
    activeLike.value = response.result?.liked;
    activeDislike.value = response.result?.disliked;
  }
  return {
    getCurrentDate,
    emit,
    likes,
    dislikes,
    activeLike,
    activeDislike,
    onError,
    onClickThumbs
  };
};
__sfc_main.components = Object.assign({
  Toggle,
  AnswerForm
}, __sfc_main.components);
export default __sfc_main;
